import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Alert, IconButton, InputAdornment } from '@mui/material';
import { ContentCopy, Check } from '@mui/icons-material';

export default function TokenSecretDialog({ open, plainTextToken, onClose }) {
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(plainTextToken);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch {
            // Fallback for older browsers
            const textArea = document.createElement('textarea');
            textArea.value = plainTextToken;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={(_, reason) => {
                if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
                onClose();
            }}
            disableEscapeKeyDown
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>API Key Created Successfully</DialogTitle>
            <DialogContent>
                <Alert severity="warning" sx={{ mb: 2 }}>
                    Store this token securely. You will not be able to view it again.
                </Alert>
                <TextField
                    fullWidth
                    value={plainTextToken || ''}
                    InputProps={{
                        readOnly: true,
                        sx: { fontFamily: 'monospace', fontSize: '0.875rem' },
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton onClick={handleCopy} edge="end">
                                    {copied ? <Check color="success" /> : <ContentCopy />}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="contained">
                    I've Saved My Token
                </Button>
            </DialogActions>
        </Dialog>
    );
}
